module.exports = "/images/envelope.png?0779a2cd83084ec0d1049651de3184fb";